module.exports = __webpack_public_path__ + "img/moon-light.695aa9a7.svg";